import React, { FC, useEffect, useRef, useState } from "react";
import ReactCalendar from "react-calendar";
import { Icon } from "assets/icons";
import { Properties } from "csstype";

import { TextInput } from "components/TextInput/TextInput";

import "react-calendar/dist/Calendar.css";
import "./calendar.css";
import styles from "./styles.module.css";

import moment from "moment";

type ValuePiece = Date | null;

export type Value = ValuePiece | [ValuePiece, ValuePiece];

interface CalendarProps {
  value: ValuePiece | [ValuePiece, ValuePiece];
  onChange: (value: Value) => void;
  visibleCalendar: boolean;
  setVisibleCalendar: (visibleCalendar: boolean) => void;
  onShow: () => void;
  optionStyle?: Properties<string | number>;
  inputClassname?: string;
  placeholder?: string;
  calendarProps?: any;
}

export const Calendar: FC<CalendarProps> = (props): JSX.Element => {
  const {
    value,
    onChange,
    visibleCalendar,
    onShow,
    setVisibleCalendar,
    optionStyle,
    inputClassname = "",
    placeholder,
    calendarProps = {},
  } = props;
  const calendarRef = useRef<HTMLDivElement | null>(null);
  const onCloseCalendar = () => setVisibleCalendar(false);

  const [localValue, setLocalValue] = useState<string>();

  const handleLocalValue = (val: string) => {
    val = val.replace(/\D/g, ""); // Remove non-numeric characters

    if (val.length > 2) {
      val = `${val.slice(0, 2)}.${val.slice(2)}`;
    }
    if (val.length > 5) {
      val = `${val.slice(0, 5)}.${val.slice(5, 9)}`;
    }

    setLocalValue(val);
  };

  const onBlur = () => {
    if (moment(localValue, "DD.MM.YYYY").isValid()) {
      onChange(moment(localValue, "DD.MM.YYYY").toDate());
    } else {
      onChange(null);
    }
  };

  useEffect(() => {
    if (!Array.isArray(value)) {
      setLocalValue(value ? moment(value).format("DD.MM.YYYY") : "");
    } else {
      setLocalValue("");
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current?.contains(event.target as Node)
      ) {
        onCloseCalendar();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onShow]);

  return (
    <div ref={calendarRef} className={styles.container}>
      <div onClick={onShow} style={{ position: "relative" }}>
        <TextInput
          className={`${styles.inputCalendar} ${inputClassname}`}
          type="text"
          value={localValue}
          placeholder={placeholder}
          onChange={(ev) => handleLocalValue(ev.target.value)}
          onBlur={onBlur}
        />
        <Icon type="arrow" className={`rotate-180 ${styles.icon}`} />
      </div>
      {visibleCalendar && (
        <div className={styles.calendarWrapper}>
          <div style={optionStyle || {}}>
            <ReactCalendar
              maxDate={new Date()}
              onChange={(val) => {
                onChange(val);
                setVisibleCalendar(false);
              }}
              value={value}
              {...calendarProps}
            />
          </div>
        </div>
      )}
    </div>
  );
};
